import React from 'react';
import { ArrowLeft, MessageCircle, User } from 'lucide-react';
interface Props {
  onBack: () => void;
}
export function MatchConnections({
  onBack
}: Props) {
  const connections = [{
    id: '1',
    name: 'Marco Rossi',
    role: 'Policy Advisor',
    company: 'FAO',
    theme: 'AI Governance',
    initials: 'MR'
  }, {
    id: '2',
    name: 'Sarah Jenkins',
    role: 'Sustainability Director',
    company: 'Barilla',
    theme: 'Climate Finance',
    initials: 'SJ'
  }];
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] px-6 pt-6 pb-24 overflow-y-auto" data-id="element-188">
      {/* Header Area */}
      <div className="flex items-center gap-3 mb-8" data-id="element-189">
        <button onClick={onBack} className="w-10 h-10 rounded-full bg-[#141414] border border-[#2A2A2A] flex items-center justify-center text-white hover:bg-[#1A1A1A] active:scale-95 transition-all duration-200" data-id="element-190">
          <ArrowLeft className="w-5 h-5" data-id="element-191" />
        </button>
        <div data-id="element-192">
          <h2 className="text-[22px] font-medium text-white tracking-tight leading-none" data-id="element-193">
            Le tue connessioni
          </h2>
          <p className="text-[13px] text-[#888888] mt-1" data-id="element-194">
            2 persone con cui hai fatto match
          </p>
        </div>
      </div>

      {/* Connections List */}
      <div className="flex flex-col gap-4" data-id="element-195">
        {connections.map(conn => <div key={conn.id} className="bg-[#141414] border border-[#2A2A2A] rounded-xl p-4 flex flex-col gap-4" data-id="element-196">
            <div className="flex items-start gap-4" data-id="element-197">
              <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center flex-shrink-0" data-id="element-198">
                <span className="text-[15px] font-medium text-white" data-id="element-199">
                  {conn.initials}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-200">
                <h3 className="text-[16px] font-medium text-white truncate tracking-tight" data-id="element-201">
                  {conn.name}
                </h3>
                <p className="text-[13px] text-[#888888] truncate" data-id="element-202">
                  {conn.role} @ {conn.company}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-between mt-2" data-id="element-203">
              <span className="bg-[rgba(255,143,0,0.12)] rounded-full px-3 py-1 text-[11px] font-medium text-white" data-id="element-204">
                {conn.theme}
              </span>
              <button className="flex items-center gap-1.5 bg-transparent border border-[#C5D82D] text-white px-4 py-1.5 rounded-full text-[12px] font-medium active:scale-95 transition-all duration-200" data-id="element-205">
                <MessageCircle className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-206" />
                Scrivi
              </button>
            </div>
          </div>)}
      </div>
    </div>;
}